<div class="rs-car-data-block-single">
    <span class="num"
          [ngClass]="{ 'icon': icon!=dataIcon.None, 'icon-user': icon==dataIcon.User, 'icon-home': icon==dataIcon.Office, 'num-zero': valueStyle==dataValueStyle.Zero, 'num-alert': valueStyle==dataValueStyle.Warn}">
        {{value}}
        @if (subValue) {
          <span>{{subValue}}</span>
        }
    </span>
    <span class="desc"
          [ngClass]="{ 'desc-alert': footerStyle==dataValueStyle.Warn }">{{footer}}</span>
</div>
